export const BeginnerPayPeriodId = Object.freeze({
  BEGINNER: 'beginner'
})
export const AdvancedPayPeriodId = Object.freeze({
  MONTHLY: 'advanced-monthly',
  ANNUALLY: 'advanced-yearly'
})
